<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">
        {{ $t('ITEM.CREATE') }} {{ $t('BUILDINGS.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <v-form ref="form" v-model="valid" lazy-validation>
            <building-form
              v-if="form"
              v-model="form"
              :errors="errors.getAll()"
              v-bind="$attrs"
              @update-prop="clearErrorByName($event)"
            />
          </v-form>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer />
      <v-btn
        depressed
        color="primary"
        :disabled="!valid"
        @click="createBuilding"
      >
        {{ $t('BUTTON.CREATE') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import BuildingForm from '@/modules/buildings/components/form/BuildingForm';
import editComponent from '@/modules/_global/mixins/edit-component';
import { mapActions } from 'vuex';

export default {
  name: 'CreateBuilding',
  components: { BuildingForm },

  mixins: [editComponent],

  props: {
    idBuildingComplex: {
      type: Number,
      required: true
    }
  },

  data: () => ({}),

  computed: {},

  mounted() {
    this.refreshData();
  },

  created() {
    this.form.building_complex_id = this.idBuildingComplex;
  },

  methods: {
    ...mapActions('building', ['store']),
    refreshData() {},

    createBuilding() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.store({ building: this.form })
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('created');
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>

<style scoped></style>
